import React from 'react';
import { Label, Modal, ModalBody } from 'reactstrap';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from 'components/App/Button';
import images from 'assets/images';
import AppAvatar from 'components/App/Avatar';

import { LANGUAGE_LABEL } from 'constants/setting';

import styles from './ModalViewContactInfo.module.scss';

const cx = classNames.bind(styles);

const ModalViewContactInfo = (props) => {
  const {
    isOpen,
    onCloseModal,
    placeContactDetails,
    onOpenDeleteModal,
    onOpenEditModal,
  } = props;
  const { t } = useTranslation();

  const contactInfo = React.useMemo(() => {
    if (!placeContactDetails) return {};
    return placeContactDetails;
  }, [placeContactDetails]);

  return (
    <Modal
      fade
      size="lg"
      isOpen={isOpen}
      toggle={onCloseModal}
      className={cx('Modal')}
    >
      <div className={cx('Modal__Header')}>
        <Label className={cx('Modal__Header__Label')}>
          Thông tin liên hệ
        </Label>

        <Button isDefault classes={cx('Button__Close')} onClick={onCloseModal}>
          <img src={images.modalClose.default} alt="" />
        </Button>
      </div>

      <ModalBody className={cx('Modal__Body')}>
        <div className={cx('Modal__Body__Content__Header')}>
          <AppAvatar
            className={cx('Header__Avatar')}
            name={contactInfo.name}
            alt={contactInfo.name}
          />
          <div className={cx('Header__Name')}>
            <p>{contactInfo.name}</p>
            <span>{t(`global.place_contact_roles.${contactInfo.role}`)}</span>
          </div>
        </div>

        <div className={cx('Modal__Body__Content__Info')}>
          <div className={cx('Info__Item')}>
            <p>Giới tính</p>
            <span>{t(`global.genders.${contactInfo.gender}`)}</span>
          </div>

          <div className={cx('Info__Item')}>
            <p>Ngôn ngữ ưu tiên</p>
            <span>{LANGUAGE_LABEL[contactInfo.mainLanguage]}</span>
          </div>

          <div className={cx('Info__Item')}>
            <p>Địa chỉ Email</p>
            <span>{contactInfo.email}</span>
          </div>

          <div className={cx('Info__Item')}>
            <p>Số điện thoại liên lạc</p>
            <div className={cx('Info__Item__PhoneNumbers')}>
              {contactInfo.phoneNumbers?.map((phone) => (
                <span key={phone}>{phone}</span>
              ))}
            </div>
          </div>
        </div>

        <div className={cx('Button__Wrapper')}>
          <Button
            classes={cx('Button', 'Button__Danger')}
            onClick={onOpenDeleteModal}
          >
            Xóa
          </Button>

          <Button
            classes={cx('Button', 'Button__Cancel')}
            onClick={onCloseModal}
          >
            Hủy
          </Button>

          <Button
            classes={cx('Button', 'Button__Edit')}
            onClick={onOpenEditModal}
          >
            Chỉnh sửa
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

ModalViewContactInfo.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onOpenDeleteModal: PropTypes.func.isRequired,
  onOpenEditModal: PropTypes.func.isRequired,
  placeContactDetails: PropTypes.instanceOf(Object),
};

ModalViewContactInfo.defaultProps = {
  placeContactDetails: {},
};

export default ModalViewContactInfo;
